module.exports = __webpack_public_path__ + "static/media/DODO-BNB.eaff0f45.svg";